import { useEffect, useState } from 'react';
import { LeapFrog } from '@uiball/loaders';
import { useTranslation } from 'react-i18next';
import { delay } from '@/helpers/delay';

import * as S from './styles';

interface LoadingProps {
  className?: string;
  withText?: boolean;
  style?: React.CSSProperties;
  customDelay?: number;
  position?: 'default' | 'absoluteCenter';
  color?: string;
}

const Loading = ({
  className,
  withText = true,
  style,
  customDelay,
  position = 'default',
  color,
}: LoadingProps) => {
  const { t } = useTranslation('global');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const setDelay = async () => {
      await delay(customDelay ?? 300);
      setLoading(true);
    };
    setDelay();
  }, [customDelay]);

  if (loading) {
    return (
      <S.Root style={style} className={className} positionType={position} data-testid='loading'>
        <LeapFrog color={color ?? '#0F8594'} />
        {/* Label color applies only when set — existing call sites rely on inheriting it. */}
        {withText && <S.Text sx={color ? { color } : undefined}>{t('loading')}</S.Text>}
      </S.Root>
    );
  } else {
    return <div />;
  }
};

export default Loading;
